module.exports = __webpack_public_path__ + "sgby/img/cloud-outside.434d484.png";